import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLinkClick = () => setMenuOpen(false);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container" ref={menuRef}>
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle ${menuOpen ? '' : 'collapsed'}`}
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <Link
            className="navbar-brand page-scroll"
            to="/#header"
            onClick={handleLinkClick}
          >
            <img
              src="/img/logo-mahance.png"
              alt="Mahanc Logo"
              style={{
                height: '30px',
                display: 'inline-block',
                marginRight: '10px',
              }}
            />
            Mahanc
          </Link>
        </div>

        <div className={`collapse navbar-collapse ${menuOpen ? 'in' : ''}`}>
          <ul className="nav navbar-nav navbar-right">
            <li>
              <Link to="/#vision" onClick={handleLinkClick}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/projects#projects" onClick={handleLinkClick}>
                Projects
              </Link>
            </li>
            <li>
              <Link to="/idea#bring-idea" onClick={handleLinkClick}>
                Submit Idea
              </Link>
            </li>
            <li>
              <Link to="/how-it-works" onClick={handleLinkClick}>
                How It Works
              </Link>
            </li>
            <li>
              <Link to="/#team" onClick={handleLinkClick}>
                Team
              </Link>
            </li>
            <li>
              <Link to="/#contact" onClick={handleLinkClick}>
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
